import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import './i18n'; // ← Initialize i18n for multi-language support
import App from './App';

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/* Support react-snap pre-rendering: hydrate if HTML already exists, else render fresh */
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}